// Precarga offline de "mis tareas" (GET /order/specialist/tareas). Usada por
// el daemon al reconectar: refresca la lista completa en background. Best-effort:
// getMisTareasApi() NO chequea res.ok — ante 401/500 devuelve un objeto de error,
// no un array. Por eso acá se valida Array.isArray(data) ANTES de guardar: un
// payload inválido no debe pisar el caché existente en silencio.
import { getMisTareasApi } from 'api/misTareas';
import { saveMisTareas } from 'utils/offlineMisTareasStore';

export async function refreshMisTareasCache() {
  try {
    const data = await getMisTareasApi();
    if (Array.isArray(data)) {
      await saveMisTareas(data);
    }
  } catch {
    // best-effort
  }
}
